import React from 'react';
import { useNavigate } from 'react-router-dom';

function CrucibleMen() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gray-900 overflow-hidden">
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-cover opacity-30"
            src="/hero-bg.jpg"
            alt="Crucible Men Background"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900 to-gray-900 mix-blend-multiply"></div>
        </div>
        <div className="relative max-w-7xl mx-auto py-16 px-6 lg:px-8 flex items-center justify-center h-full">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
              Crucible Men: Better Man Core
            </h1>
            <p className="mt-6 text-xl text-gray-300 max-w-3xl mx-auto">
              We’re stepping back into the forge this fall—and you’re invited.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-5xl mx-auto px-6 py-12">
        <section className="mb-12">
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Starting <strong>September 10th</strong>, Crucible Men will launch the
            <strong> Better Man Core</strong> series: a 12-week journey into authentic
            manhood as modeled by Jesus. This isn’t just a class—it’s a movement of men
            stepping up, sharpening each other, and fighting for what matters most.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">What to Expect</h2>
          <ul className="space-y-4 text-gray-700">
            <li>
              <strong>Biblical Manhood Defined</strong> – Learn what real manhood looks like
              and how to live it out in every area of life.
            </li>
            <li>
              <strong>Core Responsibilities</strong> – Step into your roles as protector,
              provider, and leader at home, at work, and in your community.
            </li>
            <li>
              <strong>Authentic Brotherhood</strong> – Walk alongside other men in honest
              conversations and practical growth.
            </li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Schedule</h2>
          <p className="text-gray-700">
            We’re running each session twice weekly (same content, two options):
          </p>
          <ul className="mt-4 list-disc list-inside text-gray-700 space-y-2">
            <li>📅 Wednesday Nights: 7:00 – 8:15 PM</li>
            <li>📅 Thursday Mornings: 6:00 – 7:15 AM</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Cost & Materials</h2>
          <p className="text-gray-700">
            $10 per person – covers your workbook and curriculum materials.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Why Join?</h2>
          <p className="text-gray-700 leading-relaxed">
            This journey is built around real conversations, practical tools, and a clear
            vision of manhood that works in today’s world. Whether you’re just starting your
            walk with Christ or deepening your faith as a husband, father, and leader—this
            series will challenge and equip you.
          </p>
        </section>

        {/* CTA Buttons */}
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-6">
          <a
            href="https://cbcky.churchcenter.com/registrations/events/3057109"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-6 py-3 rounded-md text-lg font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300"
          >
            Register Now
          </a>

          <button
            onClick={() => navigate('/CMDashboard')}
            className="inline-flex items-center justify-center px-6 py-3 rounded-md text-lg font-medium text-white bg-gray-800 hover:bg-gray-900 transition-colors duration-300"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default CrucibleMen;
